import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getDataForRegisterResult } from 'apis/projects.api';

const useGetDataForRegisterResult = (projectId, councilType, conds) => {
  const { data: data_, ...rest } = useQuery(
    ['getDataForRegisterResult', projectId, councilType],
    () => getDataForRegisterResult(projectId, councilType),
    {
      ...conds,
    }
  );

  const data = useMemo(() => data_?.data || [], [data_]);

  return { data, ...rest };
};

export default useGetDataForRegisterResult;
